let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("33fwI")).then(() => parcelRequire('iNCoH'));